export const CLEAR_XML = 'global/CLEAR_XML'